import { render } from "./Automations.vue?vue&type=template&id=35ff780e&scoped=true"
import script from "./Automations.vue?vue&type=script&lang=js"
export * from "./Automations.vue?vue&type=script&lang=js"

import "./Automations.vue?vue&type=style&index=0&id=35ff780e&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ff780e"]])

export default __exports__